<template>
  <v-dialog v-model="dialog" max-width="460px" :persistent="loading" @keydown.esc="close">
    <v-card v-if="access">
      <v-card-title class="headline">
        Cambiar plan
        <v-spacer />
        <v-btn icon @click="close" :disabled="loading"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-divider />

      <v-card-text class="pt-4">
        <div class="mb-3 grey--text text--darken-2">
          {{ access.companyName }} · {{ access.contratoName }}
        </div>
        <v-select
          v-model="selected"
          :items="planOptions"
          label="Plan contratado"
          :loading="loadingPlanes"
          outlined
          dense
          hide-details="auto"
        />
        <v-alert v-if="hasActiveMemberships" type="info" dense text class="mt-4 mb-0">
          Tiene {{ access.activeMemberships }} membresía(s) activa(s): solo puede quedar con
          "Todos los planes".
        </v-alert>
      </v-card-text>

      <v-divider />
      <v-card-actions class="pa-4">
        <v-spacer />
        <v-btn text @click="close" :disabled="loading">Cancelar</v-btn>
        <v-btn
          v-if="can('users:manage-company-access')"
          color="primary"
          :loading="loading"
          :disabled="!changed"
          @click="save"
        >Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CompaniesService from '../services/companie.service.js';
import ContratoService from '../services/contrato.service.js';
import { can } from '../utils/permissions';

// Valor de "Todos los planes" en el selector: se envía como planId null.
const ALL_PLANS = '__ALL__';

const ERROR_MESSAGES = {
  ACCESS_HAS_ACTIVE_MEMBERSHIPS: 'Tiene membresías activas: solo puede quedar con "Todos los planes".',
  ACCESS_PLAN_TAKEN: 'El usuario ya tiene otro acceso con ese plan en este contrato.',
  PLAN_NOT_IN_CONTRATO: 'El plan elegido no pertenece al contrato.',
  ACCESS_NOT_FOUND: 'La asociación ya no existe.'
};

export default {
  name: 'ChangeAccessPlanModal',
  props: {
    value: { type: Boolean, default: false },
    access: { type: Object, default: null }
  },
  data() {
    return {
      selected: ALL_PLANS,
      planes: [],
      loading: false,
      loadingPlanes: false
    };
  },
  computed: {
    dialog: {
      get() { return this.value; },
      set(val) { this.$emit('input', val); }
    },
    hasActiveMemberships() {
      return !!this.access && this.access.activeMemberships > 0;
    },
    // Con membresías activas solo se puede dejar el acceso sin restricción.
    planOptions() {
      const all = { text: 'Todos los planes', value: ALL_PLANS };
      if (this.hasActiveMemberships) return [all];
      return [all, ...this.planes.map(p => ({ text: p.plan.name, value: p.planId }))];
    },
    currentValue() {
      return (this.access && this.access.planId) || ALL_PLANS;
    },
    changed() {
      return this.selected !== this.currentValue;
    }
  },
  watch: {
    value(open) {
      if (open) this.load();
    }
  },
  methods: {
    can,
    async load() {
      this.selected = this.hasActiveMemberships ? ALL_PLANS : this.currentValue;
      this.planes = [];
      if (this.hasActiveMemberships || !this.access.contratoId) return;
      this.loadingPlanes = true;
      const res = await ContratoService.getById(this.access.contratoId);
      const planes = res.status === 'ok' && Array.isArray(res.data?.planes) ? res.data.planes : [];
      this.planes = planes.filter(p => p.visible);
      this.loadingPlanes = false;
    },
    async save() {
      this.loading = true;
      const planId = this.selected === ALL_PLANS ? null : this.selected;
      const res = await CompaniesService.changeAccessPlan(this.access.id, planId);
      this.loading = false;
      if (res.status === 'ok') {
        this.$emit('saved');
        this.close();
      } else {
        this.$emit('error', ERROR_MESSAGES[res.message] || 'No se pudo cambiar el plan.');
      }
    },
    close() {
      this.dialog = false;
    }
  }
};
</script>
